/**
 * O trecho citado, acima da mensagem que responde a ele.
 *
 * O defeito que trouxe este componente: o agente respondeu citando "opa" e
 * escreveu "isso aqui". No Inbox a citação aparecia; no widget chegou só "isso
 * aqui", solto — a pessoa lia uma frase sem sujeito.
 *
 * A citação não é enfeite: ela é metade do sentido da frase.
 */
import { useBrand } from "@/contexts/BrandContext";

/** Citação é referência, não transcrição. Passando disso, vira outra mensagem. */
const MAX_LENGTH = 140;

export default function ReplyQuote({ replyTo }) {
  const { displayName } = useBrand();
  if (!replyTo?.content) return null;

  const text =
    replyTo.content.length > MAX_LENGTH
      ? `${replyTo.content.slice(0, MAX_LENGTH)}…`
      : replyTo.content;

  return (
    /**
     * Contraste é o ponto aqui, não a discrição.
     *
     * A primeira versão era cinza-claro sobre fundo claro e não dava para ler.
     * Citação é conteúdo — se ela precisa de esforço para ser lida, não cumpre
     * a função de dar sujeito à frase que vem abaixo.
     */
    <blockquote className="flex flex-col gap-0.5 rounded-[8px] border-l-[3px] border-[#1d84d6] bg-black/[.07] px-2.5 py-1.5 dark:border-[#84caff] dark:bg-black/25">
      <span className="text-[11px] font-semibold text-[#1d6fb8] dark:text-[#9fd4ff]">
        {/* Quem escreveu o trecho, do ponto de vista de quem lê no widget. Do
            outro lado está a marca da plataforma (TouchWorks, ou o nome do
            parceiro em modo embutido — EMB-16) — nunca o nome de quem
            atendeu. */}
        {replyTo.fromAgent ? displayName : "Você"}
      </span>
      <span className="line-clamp-2 text-[12.5px] leading-[1.4] text-[#15161f] dark:text-white/90">
        {text}
      </span>
    </blockquote>
  );
}
